import { Card, labelDefaultMediumStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

/**
 * One heading treatment for every card on the request pages, so they read as a set:
 * 18px at medium weight, per the design.
 */
export const CardHeading = styled.h3`
  color: ${({ theme }) => theme.color.content.main as string};
  font-size: ${({ theme }) => theme.font.heading.fontSize.small};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  line-height: 1.35;
  margin: 0;
`

/** Card contents, with the same distance between the heading and what follows on every card. */
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
`

/**
 * One link for every request page. Renders as an anchor by default; pass `as` to route in-app
 * without losing the treatment.
 */
export const CardLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
  color: ${({ theme }) => theme.color.feedback.action.default as string};
  cursor: pointer;

  span {
    ${labelDefaultMediumStyles}
    font-weight: ${({ theme }) => theme.font.weight.medium};
  }

  svg {
    path {
      fill: ${({ theme }) => theme.color.feedback.action.default as string};
    }
  }
`

/**
 * The design system's Card pads its content by 24px; the request pages use 16 so the cards sit
 * tighter beside each other. Targeting the generated content classes because Card exposes no
 * padding prop.
 */
export const RequestCard = styled(Card)`
  [class*='CardContent'],
  [class*='CardBodyContent'] {
    padding: ${({ theme }) => theme.size.space['05']};
  }
`
